import baseHttpService from "core/http/singleton/base";
import {
  evaluateCampaignUrl,
  evaluateCVUrl,
  forwardEvaluationUrl,
  getCVCampaignUrl,
  getCVOfCampaignUrl,
  getDetailCampaignUrl,
  getDetailEvaluationUrl,
  getInfoSelectedCandidateUrl,
  getManagerByLevelUrl,
} from "./url";

export const getCVCampaignApi = async (payload) => {
  const { screenCode, ...rest } = payload;
  const res = await baseHttpService.get(getCVCampaignUrl(screenCode), rest);
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getManagerByLevelApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(getManagerByLevelUrl(screenCode), rest);
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const forwardEvaluationApi = async (payload) => {
  const { screenCode, programCode, ...params } = payload;
  const res = await baseHttpService.post(
    forwardEvaluationUrl(screenCode, programCode),
    params
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getCVOfCampaignApi = async (payload) => {
  const { screenCode, ...rest } = payload;

  const res = await baseHttpService.get(getCVOfCampaignUrl(screenCode), rest);
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getDetailCampaignApi = async (payload) => {
  const { screenCode, programCode } = payload;

  const res = await baseHttpService.get(
    getDetailCampaignUrl(screenCode, programCode)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getInfoSelectedCandidateApi = async (payload) => {
  const { screenCode, applyInfoId, ...rest } = payload;

  const res = await baseHttpService.get(
    getInfoSelectedCandidateUrl(screenCode, applyInfoId),
    rest
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const evaluateCVApi = async (payload) => {
  const { screenCode, itemCode, ...rest } = payload;

  const res = await baseHttpService.put(
    evaluateCVUrl(screenCode, itemCode),
    rest
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const evaluateCampaignApi = async (payload) => {
  const { screenCode, itemCode, reviewCvId } = payload;

  const res = await baseHttpService.put(
    evaluateCampaignUrl(screenCode, itemCode, reviewCvId)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getDetailEvaluationApi = async (payload) => {
  const { screenCode, reviewCvId } = payload;
  const res = await baseHttpService.get(
    getDetailEvaluationUrl(screenCode, reviewCvId)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};
